<template>
  <div id="info-detail">
    <div class="main">
      <section class="main-section">
        <h3 class="section-title green-left-head">
          お知らせ<span class="btn_to_list">
            <router-link to="/information">一覧にもどる</router-link></span
          >
        </h3>
        <div class="box-item news-detail">
          <div class="box-item-wrapper">
            <ul class="box-item-list">
              <li class="box-item-list-item">
                <div class="date">
                  {{ info.registration_at | moment("YYYY/MM/DD")
                  }}<span v-html="createTag(info.label)"></span>
                </div>
                <div class="text">{{ info.title }}</div>
              </li>
            </ul>
          </div>
        </div>

        <pre class="news-detail-text">{{ info.body }}</pre>

        <div class="news-detail-sche" v-if="info.is_schedule">
          <span class="news-detail-sche-title">スケジュール詳細：</span>
          <span class="news-detail-sche-detail"
            >{{ info.calender_text }}<br />{{
              info.calender_range.start | moment("YYYY/MM/DD HH:mm")
            }}〜{{ info.calender_range.end | moment("YYYY/MM/DD HH:mm") }}</span
          >
        </div>
      </section>
      <!--/.main-section-->
      <IconMenu />
      <!--/.main-section-->
    </div>
    <!--/.main-->
  </div>
</template>

<script>
import InfoService from "../../services/info.service";
import IconMenu from "@/components/IconMenu.vue";
export default {
  components: { IconMenu },
  name: "info-detail",
  data() {
    return {
      info: {
        target: "",
        target_user: "",
        title: "",
        body: "",
        kakomi: "",
        registration_at: "",
        display_range: { start: "", end: "" },
        url: "",
        url_target: false,
        label: "",
        is_top: false,
        is_schedule: false,
        calender_text: "",
        calender_range: { start: "", end: "" },
        notification_mail: false,
        notification_push: false,
      },
    };
  },
  async mounted() {
    console.log("info datail +++ mounted");
    await this.$nextTick();
    try {
      const response = await InfoService.findOne(this.$route.params.id);
      console.log(response);
      if (response.data.length > 0) {
        this.info = response.data[0];
      }
    } catch (error) {
      console.log(error);
      this.$router.push({ name: "notfound404" });
    }
  },
};
</script>

<style></style>
